import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import useUpdateState from '../hooks/useUpdateState';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ProjectDetailRow from './ProjectDetailRow';
import omit from 'lodash.omit';
import ProjectDetailsContractors from './ProjectDetailsContractors';
import { Row, Col } from 'react-bootstrap';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const list = ['iihrde_number_of_times_associated', 'iihrde_corresponds_by_head', 'iihrde_proportion_of_gross_wages_with_wage_tax', 'iihrde_gross_salary', 'iihrde_gs_received_by_employees_not_in_20_26', 'iihrde_gs_received_by_employees_in_20_26', 'iihrde_proportion_of_gross_wages_no_wage_tax', 'iihrde_pgs_not_in_20_26', 'iihrde_pgs_in_20_26', 'iihrde_prorota_expenditure', 'iihrde_prorota_expenditure_not_in_20_26', 'iihrde_prorota_expenditure_in_20_26', 'ocsp_working_hours', 'ocsp_working_hours_not_in_20_26', 'ocsp_working_hours_in_20_26', 'ocsce_is_civil_agreement', 'ocsce_total_remun_for_shareholders', 'ocsce_total_remun_for_project', 'ocsce_total_working_hours_shareholder_on_project', 'ocsce_total_wh_shareholder_not_in_20_26', 'ocsce_total_wh_shareholder_in_20_26', 'contractors_calculation', 'ic_rd_project_will_carried_with_affiliated_companies', 'ic_prop_carried_in_affiliated_companies', 'ic_rd_project_is_carried_with_taxexempt_research_institutions', 'ic_prop_carried_in_taxexempt_inst', 'ic_rd_project_will_carried_with_other_taxable_comapnies', 'ic_prop_carried_in_other_taxable_companies'];
const calculations = ['iihrde_number_of_times_associated', 'iihrde_corresponds_by_head', 'iihrde_proportion_of_gross_wages_with_wage_tax', 'iihrde_gs_received_by_employees_not_in_20_26', 'iihrde_gs_received_by_employees_in_20_26', 'iihrde_proportion_of_gross_wages_no_wage_tax', 'iihrde_pgs_not_in_20_26', 'iihrde_pgs_in_20_26', 'iihrde_prorota_expenditure', 'iihrde_prorota_expenditure_not_in_20_26', 'iihrde_prorota_expenditure_in_20_26', 'ocsp_working_hours', 'ocsp_working_hours_not_in_20_26', 'ocsp_working_hours_in_20_26', 'contractors_calculation'];
const ProjectDetails = _ref => {
  let {
    projectElsterDetailId,
    search
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [projectDetails, setProjectDetails] = useState(null); // {}
  useEffect(() => {
    (async () => {
      const response = await generalRouteSubRouteService.getAll(projectElsterDetailId, 'project_elster_details', 'project_detail');
      setProjectDetails({
        ...response
      });
    })();
  }, [projectElsterDetailId, search]);
  const [updateState] = useUpdateState(setProjectDetails, setIsNotSaved);
  const saveData = useErrorHandling(useCallback(async body => {
    const fieldValues = omit(body, ['id', 'project_elster_detail_id', 'created_at', 'updated_at']);
    if (Object.values(fieldValues).some(value => value < 0)) {
      throw new Error('Values must be greater than 0');
    }
    const response = await generalRouteSubRouteService.update(body.project_elster_detail_id, 'project_elster_details', 'project_detail', '', body);
    setIsNotSaved(false);
  }, []));
  const renderBsfzApplicationNumber = () => {
    if (projectDetails.project_elster_detail.claim_project_report.bsfz_certificates.length > 0) {
      return projectDetails.project_elster_detail.claim_project_report.bsfz_certificates.sort(function (a, b) {
        return a.id - b.id;
      }).at(-1).application_number;
    } else {
      return '';
    }
  };
  if (!projectDetails) return /*#__PURE__*/React.createElement("div", null, t('loading...'));
  const projectRows = list.map((fieldName, index) => {
    if (calculations.includes(fieldName) && fieldName === 'contractors_calculation') {
      return /*#__PURE__*/React.createElement(ProjectDetailsContractors, {
        projectDetails: projectDetails
      });
    } else if (calculations.includes(fieldName)) {
      return /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [fieldName, projectDetails.calculations[fieldName]],
        index: index,
        updateState: updateState,
        projectDetails: projectDetails,
        key: fieldName + 'rowData',
        disabled: true
      });
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [fieldName, projectDetails[fieldName]],
        index: index,
        updateState: updateState,
        projectDetails: projectDetails,
        key: fieldName + 'rowData',
        hasTooltip: fieldName === 'iihrde_gross_salary',
        tooltipText: fieldName === 'iihrde_gross_salary' ? t('please_fill_in_manually_if_needed') : ''
      }));
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, /*#__PURE__*/React.createElement("p", null, t('application_number'))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, renderBsfzApplicationNumber())), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, /*#__PURE__*/React.createElement("p", null, t('full_project_name'))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, projectDetails.project_elster_detail.claim_project_report.full_project_name)), projectRows, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [projectDetails]
  }));
};
export default ProjectDetails;